import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  padding: 50px;
  background-color: ${({ theme }) => theme.bg.general};
`;

export const Heading = styled.div`
  font-family: "PP Formula";
  font-size: 18px;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.text.text};
`;

export const Description = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.text.text};
`;

export const ContentWrapper = styled.div`
  display: grid;
  gap: 50px;
  grid-template-columns: 1fr 1fr;
  margin-top: 45px;

  @media (max-width: 1300px) {
    grid-template-columns: 1fr;
  }
`;

export const Macro = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`;

export const MacroLabel = styled.div`
  margin-bottom: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.input};
`;

export const Skeleton = styled.div`
  background: ${({ theme }) => theme.border.black10};
  width: 100%;
  height: 16px;
  border-radius: 4px;
  margin-bottom: 6px;
`;

export const Panel = styled.div`
  padding: 26px 20px;
  border-radius: 12px;
  color: ${({ color, theme }) => color || theme.text.title};
  border: 1px solid ${({ border, theme }) => border || theme.border.black15};
  background-color: ${({ bg, theme }) => bg || theme.bg.secondary};
  line-height: 1.4;
  font-size: 14px;
  flex: 1;
`;

export const PanelLabel = styled.strong`
  display: flex;
  align-items: center;
  margin: 0 0 15px;
  gap: 5px;
`;

export const Tabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const Tab = styled.div`
  text-align: center;
  padding-bottom: 10px;
  margin-bottom: 26px;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.text.brand : theme.text.text};
  border-bottom: 2px solid
    ${({ theme, isSelected }) =>
      isSelected ? theme.text.brand : theme.border.black10};
`;

export const Tooltip = styled.div`
  height: 14px;
  font-size: 12px;
  margin: -25px 0 0 -70px;
  background: ${({ theme }) => theme.bg.black};
  color: ${({ theme }) => theme.text.inverse};
  padding: 4px;
  border-radius: 4px;
`;
